import { TABLE_ROW_ON_CLICK } from 'root/src/client/logic/coupon/actionIds'

export default (type, payload) => ({
	type: TABLE_ROW_ON_CLICK,
	payload: { type, payload },
})
